// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Reset básico
const style = document.createElement('style');
style.innerHTML = `*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; background: #f0f2f5; }`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
